import { makeStyles, Persona, Subtitle2 } from '@fluentui/react-components';
import { useLazyFetchReviewsQuery } from '../Api/Reviews/reviewSlice';
import { useNavigate } from 'react-router';
import { useEffect } from 'react';

export interface ReviewToolstripProps {
	title: string;
	gameId?: number;
	username?: string;
	justifyContent?: 'left' | 'right';
}

/** Displays a toolstrip of related reviews based on a Game or Player passd in. */
export default function ReviewToolstrip(props: ReviewToolstripProps) {
	const { gameId, username } = props;
	const styles = useStyles();
	const navigator = useNavigate();
	const [fetchReviews, { data: reviews }] = useLazyFetchReviewsQuery();

	useEffect(() => {
		if (gameId) {
			void fetchReviews({ gameId: gameId });
		} else if (username) {
			void fetchReviews({ username: username });
		}
	}, [gameId, username, fetchReviews]);

	const itemClick = (id: number) => {
		if (id) {
			void navigator(`/reviews/${String(id)}`);
		}
	};

	return (
		<div
			className={styles.root}
			style={{ textAlign: props.justifyContent ?? 'left' }}
		>
			<div>
				<Subtitle2>{props.title}</Subtitle2>
			</div>
			<div>
				{reviews &&
					reviews.map((item, index) => (
						<Persona
							key={`review-link-${String(index)}`}
							size='large'
							name={
								props.username
									? item.videoGameTitle
									: item.username
							}
							title={
								props.username
									? item.videoGameTitle
									: item.username
							}
							primaryText=''
							avatar={{ color: 'colorful' }}
							onClick={() => {
								itemClick(item.id);
							}}
							style={{ cursor: 'pointer' }}
						/>
					))}
			</div>
		</div>
	);
}

const useStyles = makeStyles({
	root: {
		display: 'flex',
		flexDirection: 'column',
		rowGap: '2px',
		width: '100%',
		flexWrap: 'nowrap',
		overflow: 'hidden'
	},
	container: {
		display: 'flex'
	}
});
